export default __webpack_public_path__ + "static/media/main_theme.3ae71c7e.mp3";